import {getLabelByField} from "../../utils/fields/marketing.js";

const columns = [
	{
		id: 'Name',
		name: getLabelByField('Name'),
		sortable: true,
		selector: row => row.Name,
		cell: row => row.Name,
		width: '1fr'
	}, {
		id: 'Leading_Cloud__c',
		name: 'Leading Cloud',
		sortable: true,
		selector: row => row.Leading_Cloud__c,
		cell: row => row.Leading_Cloud__c,
		width: '200px'
	}, {
		id: 'Event_Type__c',
		name: 'Event Type',
		sortable: true,
		selector: row => row.Event_Type__c,
		cell: row => row.Event_Type__c,
		width: '200px'
	}, {
		id: 'Event_date__c',
		name: 'Event Date',
		sortable: true,
		selector: row => row.Event_date__c,
		cell: row => row.Event_date__c,
		width: '200px'
	}, {
		id: 'Status__c',
		name: 'Status',
		sortable: true,
		selector: row => row.Status__c,
		cell: row => row.Status__c,
		width: '200px'
	}
];

export default columns;